import React, { useState } from 'react';
import {
  Table, TableRow, TableCell, TableHead, TableBody,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useEffectAsync } from '../reactHelper';
import { useTranslation } from '../common/components/LocalizationProvider';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';
import CollectionActions from './components/CollectionActions';
import TableShimmer from '../common/components/TableShimmer';
import SearchHeader, { filterByKeyword } from './components/SearchHeader';

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: '1%',
    paddingRight: theme.spacing(1),
  },
}));

const BillingAddressesPage = () => {
  const classes = useStyles();
  const t = useTranslation();

  const [timestamp, setTimestamp] = useState(Date.now());
  const [items, setItems] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffectAsync(async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/billingaddresses?all=true');
      if (response.ok) {
        setItems(await response.json());
      } else {
        throw Error(await response.text());
      }
    } finally {
      setLoading(false);
    }
  }, [timestamp]);

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['billingInfo']}>
      <SearchHeader keyword={searchKeyword} setKeyword={setSearchKeyword} />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.columnAction} />
            <TableCell>{t('cf')}</TableCell>
            <TableCell>{t('vat')}</TableCell>
            <TableCell>{t('businessName')}</TableCell>
            <TableCell>{t('country')}</TableCell>
            <TableCell>{t('province')}</TableCell>
            <TableCell>{t('city')}</TableCell>
            <TableCell>{t('address')}</TableCell>
            <TableCell>{t('cap')}</TableCell>
            <TableCell>{t('sdi')}</TableCell>
            <TableCell>{t('pec')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading ? items.filter(filterByKeyword(searchKeyword)).map((item) => (
            <TableRow key={item.id}>
              <TableCell className={classes.columnAction} padding="none">
                <CollectionActions itemId={item.id} editPath="/billingAddress" endpoint="billingaddresses" setTimestamp={setTimestamp} />
              </TableCell>
              <TableCell>{item.cf}</TableCell>
              <TableCell>{item.vat}</TableCell>
              <TableCell>{item.businessName}</TableCell>
              <TableCell>{item.country}</TableCell>
              <TableCell>{item.province}</TableCell>
              <TableCell>{item.city}</TableCell>
              <TableCell>{item.address}</TableCell>
              <TableCell>{item.cap}</TableCell>
              <TableCell>{item.sdi}</TableCell>
              <TableCell>{item.pec}</TableCell>
            </TableRow>
          )) : (<TableShimmer columns={3} endAction />)}
        </TableBody>
      </Table>
    </PageLayout>
  );
};

export default BillingAddressesPage;
